import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BaseUserBooksView from 'rebook/apps/users/views/BaseUserBooksView';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';


class UserAllBooksView extends BaseUserBooksView {
  constructor(props) {
    super(props);

    this.title = 'Все мои книги в электронной библиотеке MyBook';
    this.breadcrumbs = [
      { text: 'Мои книги', url: `/profile/${this.props.match.params.userId}/` },
      { text: this.getInitialHeaderTitle(), url: '' },
    ];
  }

  getInitialHeaderTitle() {
    return 'Все книги и аудиокниги';
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(UserAllBooksView);
